import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export function useSetting(key: string, fallback: string = '') {
  const [value, setValue] = useState<string>(fallback);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('settings')
      .select('value')
      .eq('key', key)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled && data?.value) setValue(data.value);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [key]);

  return value;
}

export function formatDeadline(raw: string): string {
  if (!raw) return '';
  try {
    return new Date(raw).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return raw;
  }
}